/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
import {useDispatch} from 'react-redux'
import {openPopup} from '../../../Components/PopupSlice/popupSlice'

const AddEditCustomPage = () => {
  const dispatch = useDispatch()
  const [input, setInput] = useState<any>([{service: ''}])
  const [update, setUpadate] = useState(false)

  const handleAddInput = () => {
    setInput([...input, {service: ''}])
  }
  const handleRemoveInput = (index: any) => {
    const list = input
    list?.splice(index, 1)
    setInput(list)
    setUpadate(!update)
  }
  return (
    <div className={`card custom-opt-out`}>
      <div className='card-header border-0 pt-15 ps-15'>
        <h3 className='card-title align-items-start flex-column me-5'>
          <span className='card-label fw-bolder fs-2 mb-1'>Create your custom-opt-out page</span>
          <span className='text-muted mt-1 fw-light fs-7'>
            If you still need more info, visit{' '}
            <a onClick={() => dispatch(openPopup('Dummy text'))} className='fw-light'>
              Help Page
            </a>
          </span>
        </h3>
      </div>
      <div className='card-body py-3 mt-10'>
        <div className='row container'>
          <div className='col-lg-5 p-0 custom-left'>
            {/* <form className='form'> */}
            <div className='mb-10'>
              <label className='form-label'>Template Name</label>
              <input
                type='text'
                className='form-control bg-light border-0'
                placeholder='VIP party opt-out'
              />
            </div>
            {/* <div className='mb-10'>
              <div className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  type='radio'
                  value=''
                  id='flexRadioChecked'
                  checked={useDefault}
                  onChange={() => {
                    setUseDefault(true)
                    setCustomizeField(false)
                  }}
                />
                <label
                  className='form-check-label align-items-start flex-column d-flex'
                  htmlFor='flexRadioChecked'
                >
                  <span className='card-label fw-bolder fs-5'>Use Default opt-out page</span>
                  <span className='text-muted  fs-7'>Use our pre defined fields</span>
                </label>
              </div>
            </div> */}
            {/* <div className='mb-10 mt-10'>
              <div className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  type='radio'
                  value=''
                  id='flexRadioChecked'
                  checked={customizeField}
                  onChange={() => {
                    setCustomizeField(true)
                    setUseDefault(false)
                  }}
                />
                <label
                  className='form-check-label align-items-start flex-column d-flex d-block'
                  htmlFor='flexRadioChecked'
                >
                  <span className='card-label fw-bolder fs-5'>Customize fields</span>
                  <span className='text-muted  fs-7'>
                    Choose which option your customer will have
                  </span>
                </label>
              </div> */}
            {/* {customizeField === true && ( */}
            <div className='mb-10 align-items-start flex-column d-flex'>
              <label
                className='form-check-label align-items-start flex-column d-flex d-block'
                htmlFor='flexRadioChecked'
              >
                <span className='card-label fw-bolder fs-5'>Customize fields</span>
                <span className='text-muted  fs-7'>
                  Choose which option your customer will have
                </span>
              </label>
              {input?.map((input1: any, idx: number) => (
                <React.Fragment key={idx}>
                  <div className='input-group input-group-solid mt-5 w-349px'>
                    <input
                      className='form-control rounded'
                      placeholder='Custom field'
                      type='text'
                      aria-label="Recipient's username"
                      aria-describedby='basic-addon2'
                    />
                    <span className='ms-2' id='basic-addon2'>
                      <WSButton
                        className='btn btn-lg btn-icon btn-light btn-light-danger fw-500'
                        onClick={() => handleRemoveInput(idx)}
                        disabled={input?.length > 1 ? false : true}
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr061.svg'
                          className='svg-icon-2'
                        />
                      </WSButton>
                    </span>
                  </div>
                  <div className='w-100'>
                    <div className='col-lg-12'>
                      {input?.length - 1 === idx && input?.length < 4 && (
                        <WSButton
                          className='mt-5 btn btn-lg  btn-light btn-light-primary text-primary text-hover-white me-2 w-100'
                          onClick={handleAddInput}
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr075.svg'
                            className='svg-icon-1'
                          />
                          Add another option
                        </WSButton>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
            {/* )} */}
            {/* </div> */}
            <div className='d-flex justify-content-start'>
              <WSButton
                type='submit'
                className='btn btn-sm btn-light btn-primary me-2 w-100px p-3 fw-500 '
                data-kt-search-element='advanced-options-form-cancel'
              >
                Save
              </WSButton>
              <WSButton
                className='btn btn-sm bg-white fw-500 text-primary   me-2 w-100px p-3 border border-primary me-2'
                data-kt-search-element='advanced-options-form-cancel'
              >
                Cancel
              </WSButton>
            </div>
            {/* </form> */}
          </div>
          <div className='col-lg-7 d-flex justify-content-center align-items-center mb-10 custom-right'>
            <div className='mb-10 ms-5 margincls'>
              <img
                src={toAbsoluteUrl('/media/mobile/iPhone.png')}
                alt='logo'
                className='w-300px h-500px'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddEditCustomPage
